<template>
    <div>
        <el-dialog class="lnk-picklist"
                   :close-on-click-modal="false"
                   :visible.sync="isShow"
                   :title="title || pickOption.title"
                   width="600"
                   :append-to-body="appendToBody"
                   :modal-append-to-body="modalAppendToBody">
            <lnk-simple-table v-model="selectedData"
                              ref="mainTable"
							  :http-instance="httpInstance"
                              :pageSizes="pageSizes"
							  :row-height="rowHeight"
							  :header-height="headerHeight"
							  :show-page-num="false"
                              :multi-select="pickOption.multiSelect"
                              :multi-select-cache="pickOption.multiSelectCache"
                              :rownumbers="pickOption.rownumbers"
                              :oauth="pickOption.oauth ? pickOption.oauth : 'ALL'"
                              :url="pickOption.url"
                              :sort-name="pickOption.sortName"
                              :sort-order="pickOption.sortOrder"
                              :default-no-query="pickOption.defaultNoQuery"
                              :fields="pickOption.fields"
                              :params="queryParams"
                              :prop-main="pickOption.propMain"
                              @row-dblclick="comfirmSelect">
                <!--提供自定义列表插槽 -->
                <template slot="prepend" slot-scope="prepend">
                    <slot name="prepend-col" :main="prepend.main"></slot>
                </template>
                <template slot="append" slot-scope="append">
                    <slot name="append-col" :main="append.main"></slot>
                </template>
            </lnk-simple-table>
            <!-- 弹出框确定与取消按钮 -->
            <span slot="footer" class="dialog-footer">
                <link-button type="line" @click="isShow = false">{{$t('global.cancel')}}</link-button>
                <link-button @click="comfirmSelect">{{$t('global.confirm')}}</link-button>
            </span>
        </el-dialog>

		<template v-if="isInput">
			<multi-inputbox
				v-if="isMulti"
				class="lnk-picklist__multi-input"
				:size="size"
				@change="multiChange"
				:disabled="isInputDisabled"
				:tag-label-field="inputTaglabelField"
				:placeholder="placeholder"
				v-model="multiInput"
				@icon-click="open"/>
			<el-input
				v-else
				v-model="inputValue"
				@change="inputChange"
				class="lnk-picklist__input"
				:disabled="isInputDisabled"
				:size="size"
				:readonly="readonly"
				:placeholder="placeholder">
				<template slot="suffix">
					<link-icon v-if="isClearShow" @click="clearValue" class="lnk-picklist__clear" icon="link-icon-close"></link-icon>
					<link-icon v-if="isInputDisabled" icon="link-icon-search"></link-icon>
					<link-icon v-else icon="link-icon-search" @click="open"></link-icon>
				</template>
			</el-input>
		</template>
    </div>
</template>

<script>
/* eslint-disable no-underscore-dangle,no-prototype-builtins */


import multiInputbox from './multi-inputbox';
import {getFitRows} from "./index";
import {typeOf} from "@utils/linktools";
import deepmerge from 'deepmerge';

export default {
    name: 'lnk-picklist',
    components: {multiInputbox},
    inject: { // 获取父组件的provide
        elForm: {default: ''},
        elFormItem: {default: ''}
    },
	model: {
		prop: 'inputVal', // prop说:我要在该组件被使用(被父组件调用)时,v-model的值绑定给storeObj
		event: 'innerChange'// event说:我emit(触发)innerChange，参数的值就是父组件v-model收到的值。
	},
    props: {
      	// 单独指定使用的http实例，不指定则按默认规则
      	httpInstance: Object,
    	/* picklist标题 */
		title: String,
		/* 指定picklist的配置对象 */
		name: String,
		/* 公共配置对象，若是字符串，则默认取公共picklist对象里同名的配置 */
		commonGridOptions: [Object, String],
		/* 自定义配置对象 */
		gridOptions: {type: Object,default: ()=>({})},
		/* 是否多选 */
        multi: Boolean,
		/* 自定义参数 */
        params: Object,
		/* 要排除的id记录*/
		excludeIds: Array,
		/* 是否显示弹框 */
        show: Boolean,
		/* 加载远程配置链接 */
        remote: String,
		/* 弹框打开前的钩子函数 */
		beforeOpen: Function,
		/* 执行操作前的钩子函数 */
		beforePick: Function,
	  	/* 执行操作前的钩子函数 */
		beforeClear: Function,
		/*弹出框打开前 点击搜索按钮*/
		beforeShowPicklist:{type: Function},
		/* 打开弹框时刷新列表 */
        freshOnshow: Boolean,
		/* Dialog 自身是否插入至 body 元素上。 */
        appendToBody: { //
            type: Boolean,
            default: true
        },
		/* Dialog 遮罩是否插入至 body 元素上。 */
        modalAppendToBody: {
            type: Boolean,
            default: true
        },
		/* 是否可清除*/
		clearable: Boolean,
		/* picklist是否可用 */
        disabled: Boolean,
		/* input类型时v-model绑定的值 */
        inputVal: [String, Object, Array],
		/* picklist展示形式，input表示用输入框 */
        picklistType: String,
		/* 主要字段 */
        mainField: String,
		/* 属性映射，key为picklist列表字段名称，value为返回字段名称 */
        pickMap: Object, //
		/* 配合pickMap使用修改绑定对象的属性值 */
        pickObject: Object,
		/* 输入框尺寸 */
        size: {type: String, default: 'mini'},
		/* 输入提示 */
        placeholder: {type: String, default: '请选择'},
		/* 输入框是否为只读控制 */
        readonly:{ type: Boolean, default: true},
        /* 多选标签的展示字段 */
        tagLabelField: String,
        /* 当前选中内容 */
        selected: [Object, Array],
        /* 强制change事件返回属性映射以后的结果*/
        forceMapped: Boolean,
		/*列表行的高度*/
		rowHeight: {type: [String, Number], default: 32},
		/*列表头的高度*/
		headerHeight: {type: [String, Number], default: 32}
    },
	data(){
		return {
			selectedData: null, // picklist绑定数据
			remoteConf: null, // 远程配置对象
			isShow: Boolean(this.show), //是否显示弹框
			isConfirming: false, //是否正在处理确定操作
			multiInput: [], //多选的数据
			inputValue: this.inputVal, //单选输入框绑定值
			fitRows:[10,20,30,40,50], //默认的pageSizes
			queryParams: {} //参数传递容器，用于在打开弹框时更新参数
		};
	},
    computed: {
      	// 获取真正使用的http实例
	  	$$http() {
			return this.httpInstance || this.$http;
		},
		/* picklist配置对象 */
		pickOption(){

			let option = {};

			/* 检查是否有公用的pick对象linkPicklist的键值 */
			let globalKey = this.name;
			if(!globalKey && typeOf(this.commonGridOptions) === 'string'){
				globalKey = this.commonGridOptions;
			}

			/* 如果有 globalKey 则将相对应的配置作为默认值 */
			if(globalKey){
				const linkPicklist = typeof window.linkPicklist === "function" ? window.linkPicklist() : window.linkPicklist
				option = Object.assign(option, linkPicklist[globalKey]);
			}

			/* 如果有远程配置，则深度合并*/
			if(typeOf(this.remoteConf) === 'object'){
				option = deepmerge(option, this.remoteConf, {clone:true});
			}
			/* 如果有commonGridOptions，则深度合并 */
			if(typeOf(this.commonGridOptions) === 'object'){
				option = deepmerge(option, this.commonGridOptions, {clone:true});
			}
			/* 如果有gridOptions，则深度合并 */
			if(typeOf(this.gridOptions) === 'object'){
				option = deepmerge(option, this.gridOptions, {clone:true});
			}

			/* 如果multi属性为true,则将option的多选置为true */
			if(this.multi){
				option.multiSelect = true;
			}

			return option;
		},
		/* 是否为多选模式 */
		isMulti(){
			return this.pickOption.multiSelect;
        },
		/*是否为输入框模式*/
		isInput(){
			return this.picklistType === 'input';
		},
		/* 是否显示单选的清除按钮 */
		isClearShow(){
			return !this.isInputDisabled && this.clearable && this.inputValue;
		},
		/* 多选输入框的显示字段 */
        inputTaglabelField(){
            var option = this.pickOption || {};
            return this.tagLabelField || option.tagLabelField || this.mainField || 'id';
        },
		/* 输入框是否禁用 */
		isInputDisabled(){
			return this.disabled || (this.elForm || {}).isDisabled || (this.elFormItem || {}).isDisabled;
		},
        /* 表格左下角的分页可选条数 */
        pageSizes(){
            let {pageSizes} = this.pickOption;
            if(!(pageSizes || [])) {
                pageSizes = this.fitRows;
            }
            return pageSizes;
        }
    },
    watch: {
        isShow(value){
			if(value !== this.show){
				this.$emit('update:show', value);
			}
			if(!value){
				this.onClose();
			}
		},
        show(value) {
			if(value === this.isShow) return;
			if(value){
				this.open();
			}else {
				this.isShow = false;
			}
        },
        inputVal(value){
        	if(this.isMulti){
        		this.multiInput = value;
			}else {
        		this.inputValue = value;
			}
		},
    },
    methods: {
		/**
		 *@createdBy 常九福
		 *@date 2019/11/7
		 *@methods:beforeClickPicklist
		 *@description: 显示picklist之前
		 **/
		beforeClickPicklist(){
			if(this.beforeShowPicklist && !this.beforeShowPicklist()){
				return false;
			}
			this.isShow = this.isInputDisabled ? this.isShow: true;
		},
    	/**
    	 * @method：	初始化
    	 * @createdBy：黄健
    	 * @date：2020-02-08
    	 * @params：
    	 * @description：init
    	 */
    	init(){
			this.fitRows = getFitRows();
			if(this.show){
				this.open();
			}
			if (this.remote) {
				this.$$http.post(this.remote, {}).then((data) => {
					this.remoteConf = data;
				});
			}
		},
		/**
		 * @method：open
		 * @createdBy：黄健
		 * @date：2020-02-08
		 * @params：
		 * @description：打开弹框
		 */
		async open(){
			/* 钩子函数执行不成功就不打开弹框 */
			if(typeOf(this.beforeOpen) === 'function'){
				try {
					const isPassed = await this.beforeOpen();
					if(!isPassed) throw new Error('');
				}catch (e) {
					return;
				}
			}
			this.isConfirming = false;

			const queryParams = this.getQueryParams();
			const isParamsChanged = JSON.stringify(queryParams) !== JSON.stringify(this.queryParams);

			const simpleTable = this.$refs.mainTable;

			if(isParamsChanged){
				if(simpleTable) simpleTable.dataList = [];
				this.queryParams = queryParams;
			}

			if(this.freshOnshow && !isParamsChanged && simpleTable){
				simpleTable.dataList = [];
				simpleTable.setPageFirstAndQueryData();
			}
			this.isShow = true;
			this.$emit('open');
		},
		/**
		 * @method：onClose
		 * @createdBy：黄健
		 * @date：2020-02-08
		 * @params：
		 * @description：关闭弹框后操作
		 */
		onClose(){
			const elTable = this.$getChildComponent('el-table');
			if(elTable){
				elTable.clearSelection();
			}
			const simpleTable = this.$refs.mainTable;
			if(simpleTable){
				simpleTable.clearSelectedCache();
			}
		},
		/**
		 * @method：clearValue
		 * @createdBy：黄健
		 * @date：2020-02-08
		 * @params：
		 * @description：清除当前值，仅单选有效
		 */
		async clearValue(){
			if(!this.isInput || this.isMulti) return;

          	/* 钩子函数执行不成功就跳过确认操作 */
          	if(typeOf(this.beforeClear) === 'function'){
              try {
                const isPassed = await this.beforeClear();
                if(!isPassed) return;
              }catch (e) {
                console.warn(e)
                return;
              }
          	}
			const pickMap = this.pickMap;

			/*是否需要映射转化*/
			const isPickMap = typeOf(pickMap) === 'object' && Object.keys(pickMap).length>0;

			if(isPickMap && typeOf(this.pickObject) === 'object'){
				Object.keys(pickMap).forEach((key)=>{
					this.$set(this.pickObject, pickMap[key], '');
				});
			}
			this.$emit('innerChange', '');
			this.$emit('change', null);
			this.$emit('update:selected', null);
			this.$emit('clear');
		},

		/**
		 * @method：multiChange
		 * @createdBy：黄健
		 * @date：2020-02-08
		 * @params：
		 * @description：多选输入框的变化
		 */
		multiChange(value){
			this.$emit('innerChange', value);
			this.$emit('change', value);
			this.$emit('update:selected', value);
		},
		/**
		 * @method：单选输入框的变化
		 * @createdBy：黄健
		 * @date：2020-02-08
		 * @params：
		 * @description：
		 */
		inputChange(value){
			this.$emit('innerChange', value);
		},
		/**
		 * @method：getQueryParams
		 * @createdBy：黄健
		 * @date：2020-02-08
		 * @params：
		 * @description：获取查询的参数
		 */
		getQueryParams(){
			let params = {};

			/*计算要排除的id*/
			const pickMap = this.pickMap;
			const isPickMap = typeOf(pickMap) === 'object' && Object.keys(pickMap).length>0;
			const excludeIds = typeOf(this.excludeIds) === 'array'? [...this.excludeIds] : [];
			if(this.isMulti){
				(this.multiInput || []).forEach((t)=>{
					if(!t) return;
					const idStr = t.id || t[pickMap.id];
					if(idStr && excludeIds.indexOf(idStr)<0) excludeIds.push(idStr);
				})
			}

			/*如果有需要排除的id, 则深度合并*/
			if(excludeIds.length){
				params = Object.assign({},{filtersRaw:[{
					id:`lnk_picklist_id_${this._uid}`,
					property: 'id',
					operator: 'not in',
					value: `[${excludeIds}]`
				}]});
			}

			/*深度合并初始参数*/
			if(typeOf(this.pickOption.params) === 'object'){
				params = deepmerge(params, this.pickOption.params, {clone:true});
			}

			/*如果有自定义的参数, 则深度合并*/
			if(typeOf(this.params) === 'object'){
				params = deepmerge(params, this.params, {clone:true});
			}

			return params;
		},
		/**
		 * @method：comfirmSelect
		 * @createdBy：黄健
		 * @date：2020-02-07
		 * @params：
		 * @description：点击确定
		 */
        async comfirmSelect(){
			if(this.isConfirming) return;
			this.isConfirming = true;

			let selected = this.selectedData;

			/* 钩子函数执行不成功就跳过确认操作 */
			if(typeOf(this.beforePick) === 'function'){
				try {
					const isPassed = await this.beforePick(selected);
					if(!isPassed) throw new Error('');
				}catch (e) {
					this.isConfirming = false;
					return;
				}
			}

            if(this.isMulti){
            	if(!selected.length){
            		this.$alert('至少要选择一条数据','提示',{type: 'waring'});
					this.isConfirming = false;
					return;
				}
			}else if(!selected){
				this.$alert('请选择一条记录','提示',{type: 'waring'});
				this.isConfirming = false;
				return;
			}

			const pickMap = this.pickMap;

            let mappedData = selected;

			/*是否需要映射转化*/
			const isPickMap = typeOf(pickMap) === 'object' && Object.keys(pickMap).length>0;

			/*按照pickMap转化*/
			if(isPickMap){
				if(this.isMulti){
					mappedData = mappedData.map((row)=>{
						const newItem = {};
						Object.keys(pickMap).forEach((key)=>newItem[pickMap[key]] = row[key]);
						return newItem;
					});
				}else {
					const newItem = {};
					Object.keys(pickMap).forEach((key)=>newItem[pickMap[key]] = selected[key]);
					mappedData = newItem;
				}
			}

			/*选择的数据，有pickMap就用转化后的数据*/
			const pickData = isPickMap?mappedData:selected;

			/*单选时，如果绑定了pickObject，就pickMap中的映射关系给其赋值*/
			if(isPickMap && !this.isMulti && typeOf(this.pickObject) === 'object'){
				Object.keys(mappedData).forEach((key)=>{
					this.$set(this.pickObject, key, mappedData[key]);
				});
			}

			/*多选输入框*/
			if(this.isInput && this.isMulti){
				this.multiInput = (this.multiInput || []).concat(pickData);
				this.$emit('innerChange', this.multiInput);

			/*单选输入框*/
			}else if(this.isInput && !this.isMulti){
				/*没有mainField就跳过model事件*/
				if(this.mainField){
					const key = this.mainField;
					let newValue = '';
					if(selected.hasOwnProperty(key)){
						newValue = selected[key];
					}else if(mappedData.hasOwnProperty(key)){
						newValue = mappedData[key];
					}
					this.$emit('innerChange', newValue);
				}

			/*多选非输入框*/
			}else if(this.isMulti && !this.isInput){
				this.$emit('innerChange', pickData);

			/*单选非输入框*/
			}else {
				const newItem = linkTools.deepCopy(this.inputVal) || {};
				Object.keys(pickData).forEach((key)=>newItem[key] = pickData[key]);
				this.$emit('innerChange', newItem);
			}

			// @add by 常九福 在向外map赋值前 将数据传递出去
			this.$emit('beforeMap', selected);

			/*给定了forceMapped属性为true,就在change事件中回调转化后的数据*/
			if(isPickMap && this.forceMapped){
				this.$emit('change', pickData);
			}else this.$emit('change', selected);

            this.$emit('update:selected', pickData);
            this.isShow = false;
        }
    },
    created() {
    	this.init();
    }
};
</script>

<style lang="scss">
    .lnk-picklist .el-dialog__body .el-link-toolbar.el-row{
        margin: 0 0 8px 0!important;
    }
    .lnk-picklist {
        overflow: hidden;
        .el-dialog{
            width: 50vw;
            margin-top: 50vh!important;
            transform: translateY(-50%);
        }
        .el-dialog__body{
            /*max-height: initial!important;*/
            padding: 12px 16px;
        }
        .lnk-simple-table {
			.el-table::before{
				visibility: visible;
			}
			.el-link-toolbar + .el-table-box{
				margin-top: 8px;
			}
            .el-table-box{
                .el-table {
                    .el-table__row{
                        cursor: pointer;
                    }

                }
            }
			.lnk-pagination-v{
				border: 0!important;
				height: 28px!important;
				padding: 0!important;
				margin-top:8px;
			}
        }
    }

	.lnk-picklist__input{
		.el-input__suffix .lnk-picklist__clear.link-icon{
			opacity: 0;
			margin-right: 2px;
		}
		&:hover .el-input__suffix .lnk-picklist__clear.link-icon{
			opacity: 1;
		}
	}
</style>
